module.exports = __webpack_public_path__ + "img/34.88cd1b40.jpg";